import type { EncryptionContext, EncryptionInfo } from "../types";

import { fromBuffer } from "./buffer";
import { encryptWithCryptoKey, getCryptoKey } from "./crypto-actions";

export const encrypt = async (
    plaintextData: string,
    { plaintextDataKey, context }: EncryptionContext,
): Promise<EncryptionInfo> => {
    const cryptoKey = await getCryptoKey(plaintextDataKey);
    const { buffer: ivBuffer } = crypto.getRandomValues(new Uint8Array(12));
    const iv = fromBuffer(ivBuffer, "base64");
    const ciphertextBuffer = await encryptWithCryptoKey({ cryptoKey, data: plaintextData, context, ivBuffer });
    const ciphertext = fromBuffer(ciphertextBuffer, "base64");

    return {
        encryptedData: ciphertext,
        IV: iv,
    };
};
